import { Box } from '@mui/material';
import NumberFormat from 'react-number-format';
import { UseTableCellProps } from 'react-table';
import { Product } from 'shared/types';

export default function NumberColumn({ value }: UseTableCellProps<Product>) {
    return (
        <Box height='100%' display='flex' justifyContent='center' alignItems='center'>
            <NumberFormat value={value} displayType='text' thousandSeparator={true} prefix={'$'} />
        </Box>
    );
}
